import { css } from '@emotion/core'
import styled from '@emotion/styled'
import SimpleBar from 'simplebar-react'

import { transientOptions } from '../../../../constants/transientOptions'
import { MODULE_LAYOUT_BOTTOM_SPACE } from '../../constants/moduleLayoutBottomSpace'

interface ModuleContentProps {
  $fullHeight?: boolean
}

export const ModuleContent = styled(SimpleBar, transientOptions)<ModuleContentProps>`
  display: flex;
  overflow: auto;

  /* Remove Simplebar's default focus status (box-shadow) on content wrapper */
  .simplebar-content-wrapper:first-of-type:focus-visible {
    box-shadow: none;
  }

  ${({ $fullHeight }) =>
    $fullHeight &&
    css`
      flex: 1;
      min-height: 0;

      /* Simplebar's wrapper inherits its height from this element, which has none of its own, so it
         collapses to an auto height and every percentage height below it resolves to auto.
         Pinning it lets the absolutely positioned .simplebar-mask/.simplebar-offset size against it. */
      .simplebar-wrapper {
        height: 100%;
      }

      /* .simplebar-content is what Simplebar's ResizeObserver watches to detect content-height
         changes. A plain height: 100% pins its own box to a constant size, which defeats that
         detection: swapping in taller/shorter content (e.g. an invoice preview iframe resizing
         itself once it finishes loading) can leave the scrollbar stuck until something unrelated,
         like a window resize, forces a recalculation. min-height keeps the "fill the viewport when
         content is short" behaviour, but lets the box grow with taller content so resize detection
         keeps working. Its child (Container's root element, always the sole child here) gets a
         definite flex-basis to stretch from instead of a percentage height, since a percentage
         can't resolve against a min-height-driven size. */
      .simplebar-content {
        display: flex;
        flex-direction: column;
        min-height: 100%;

        > div {
          flex: 1;
          height: auto;
          min-height: 0;
        }
      }

      ${InnerContent} {
        padding-bottom: 0;
      }
    `}
`
export const InnerContent = styled.section`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-bottom: ${MODULE_LAYOUT_BOTTOM_SPACE};
  position: relative;
`
